import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getPublishedOpenApiSpecs,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { PublishedPages } from '../../components/PublishedPages/PublishedPages';

export const PublishedApiDocs = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Open Api Specs'
      }
    ]);
  }, []);
  return <PublishedPages nameField="version" {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  publishedPages: state.getIn([NS, 'publishedOpenApiSpecs']),
  pending: state.getIn([NS, 'pending', 'publishedOpenApiSpecs']),
  canEdit: state.getIn([NS, 'team', 'is_member'], false)
});
const mapDispatchToProps = dispatch => ({
  getPublishedPages: serviceHandle =>
    dispatch(getPublishedOpenApiSpecs(serviceHandle)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishedApiDocs);
